export const SET_ELCDOOR_SWITCH_RECORDS = 'ELCDoorRecords/Switch/set';
export const SET_ELCDOOR_REPLACE_RECORDS = 'ELCDoorRecords/Replace/set';
